<button
  [type]="type"
  class="lib-button"
  [class.variant-primary]="variant === 'primary'"
  [class.variant-secondary]="variant === 'secondary'"
  [class.variant-danger]="variant === 'danger'"
  [class.variant-success]="variant === 'success'"
  [class.variant-outline]="variant === 'outline'"
  [class.variant-text]="variant === 'text'"
  [class.size-sm]="size === 'sm'"
  [class.size-md]="size === 'md'"
  [class.size-lg]="size === 'lg'"
  [class.full-width]="fullWidth"
  [class.has-icon]="icon"
  [class.loading]="loading"
  [disabled]="disabled || loading"
  (click)="onClick($event)"
>
  @if (loading) {
  <span class="button-spinner">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="7"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-dasharray="43.98"
        stroke-dashoffset="10"
        opacity="0.3"
      />
      <circle
        cx="8"
        cy="8"
        r="7"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-dasharray="43.98"
        stroke-dashoffset="33"
      />
    </svg>
  </span>
  } @if (icon && iconPosition === 'left' && !loading) {
  <span class="button-icon button-icon-left">
    <ng-content select="[slot=icon-left]"></ng-content>
  </span>
  }

  <span class="button-text">
    <ng-content></ng-content>
  </span>

  @if (icon && iconPosition === 'right' && !loading) {
  <span class="button-icon button-icon-right">
    <ng-content select="[slot=icon-right]"></ng-content>
  </span>
  }
</button>
